export default function resolveCompanyName(
    infoCompanyName: string | null | undefined,
    tokenCompanyName: string | null | undefined,
): string | null {
    if (infoCompanyName) {
        return infoCompanyName;
    }

    if (tokenCompanyName) {
        return tokenCompanyName;
    }

    return null;
}
